import { useGetCurrentUserQuery } from '@graphql/requests';

export const useAuthStatus = () => {
  const { data } = useGetCurrentUserQuery();

  return data?.authStatus;
};
